import { createRequest, handleErrorCatchLog } from '../../Helpers/GenericHelpers'
import { retrieveSelectedArticleKey } from '../../Helpers/ArticlesHelper'
import { getTokenFromSessionStorage } from 'Helpers/TokenHelper'
import { handleDescriptions } from './ArticleServices'

const saveDescriptonChanges = changedDescription => (dispatch, getState) => {
  const state = getState()
  const rowKeysSelected = state.present.article.rowKeysSelected
  const token = getTokenFromSessionStorage()

  const articleKey: any = retrieveSelectedArticleKey(rowKeysSelected)

  if (!state.present.article.serverConfig || !articleKey || !token) {
    return new Promise(resolve => {
      resolve([])
    })
  }

  const body = {
    DescriptionsField: changedDescription,
  }

  return createRequest(
    '/api/articles/' + articleKey + '/updateDescriptions?config=' + state.present.article.serverConfig,
    'POST',
    body,
    token,
  )
    .then(response => response.json())
    .then(data => {
      handleDescriptions(articleKey, dispatch)()
    })
    .catch(err => {
      handleErrorCatchLog(err, 'Failed to save descriptions changes')
    })
}

export { saveDescriptonChanges }
